import { createSelector } from 'reselect'

const getPortals = state => state.marker.portals;
const getBounds = state => state.map.mapBounds;

export const selectVisiblePortals = createSelector(
	[getPortals, getBounds],
	(portals, bounds) => {
		let list = Object.values(portals);

		list = list.filter(data =>
			data.latitude  < bounds[0][0] && data.latitude  > bounds[1][0] &&
			data.longitude < bounds[0][1] && data.longitude > bounds[1][1]
		);

		return list;
	}
);